module.exports = __webpack_public_path__ + "static/banner-6dd93d900c4cbee88d1f6e439c758e82.jpg";